<template>
  <div class="home">
    <!-- 标语 -->
    <div class="slogan container" v-if="webPositionData[0]">
      <div v-if="webPositionData[0]['infoData'].length > 0">
        <h2 @click="detailHandle(webPositionData[0]['infoData'][0])" class="h2-title">
          <img src="../assets/images/1304/hot-new.png" alt="" class="img"/>
          <div class="div-title">
            <p class="firsttitle">{{ webPositionData[0]['infoData'][0]['strMasTitle'] }}</p>                    
           <!--  <p class="sectitle">
              {{ webPositionData[0]['infoData'][0]['strRowTitle'] }}
            </p> -->
          </div>
        </h2>
        <div class="tit-box">
          <!-- 如果只有副标题存在 后台控制只返回一条信息 字段为strSecTitle -->
          <span
            @click="detailHandle(webPositionData[0]['infoData'][0])"
            v-if="
              !!webPositionData[0]['infoData'][0] &&
              webPositionData[0]['infoData'].length == 1 &&
              webPositionData[0]['infoData'][0].strSecTitle
            "
            >{{ webPositionData[0]['infoData'][0].strSecTitle }}</span
          >
          <span v-if="!!webPositionData[0]['infoData'][1]" @click="detailHandle(webPositionData[0]['infoData'][1])">
            {{ webPositionData[0]['infoData'][1].strMasTitle }}
          </span>
          <span v-if="!!webPositionData[0]['infoData'][2]" @click="detailHandle(webPositionData[0]['infoData'][2])">
            {{ webPositionData[0]['infoData'][2].strMasTitle }}
          </span>
          <span v-if="!!webPositionData[0]['infoData'][3]" @click="detailHandle(webPositionData[0]['infoData'][3])">
            {{ webPositionData[0]['infoData'][3].strMasTitle }}
          </span>
          <span v-if="!!webPositionData[0]['infoData'][4]" @click="detailHandle(webPositionData[0]['infoData'][4])">
            {{ webPositionData[0]['infoData'][4].strMasTitle }}
          </span>
        </div>
      </div>
      <div v-else class="no-content">暂无数据</div>
    </div>
    <div class="top container news-kms">
      <!-- Swiper -->
      <!-- 左侧新闻 -->
      <Vswiper v-if="webPositionData[1]" :isSpecial="isSpecial" :swiperArr="webPositionData[1]['infoData']"></Vswiper>
      <div class="news-main" v-if="webPositionData[3]">
        <div v-if="webPositionData[3]['infoData'].length > 0">
          <div
            class="rows-zt"
            @click="detailHandle(webPositionData[3]['infoData'][0])"
            v-if="webPositionData[3]['infoData'][0]"
          >
            <div class="tit-zt">
              <span class="text">{{ webPositionData[3]['infoData'][0].strMasTitle }}</span>
              <span class="more" @click.stop="toList(webPositionData[3].strId)">更多>></span>
            </div>
            <div class="con-zt">
              {{ webPositionData[3]['infoData'][0].strText }}
            </div>
          </div>
          <div
            class="rows-zt"
            @click="detailHandle(webPositionData[3]['infoData'][1])"
            v-if="webPositionData[3]['infoData'][1]"
          >
            <div class="tit-zt">
              <div class="text">
                {{ webPositionData[3]['infoData'][1].strMasTitle }}
              </div>
            </div>
            <div class="con-zt">
              {{ webPositionData[3]['infoData'][1].strText }}
            </div>
          </div>
          <ul v-if="webPositionData[3]['infoData'].length > 1">
            <li
              class="text-one"
              v-for="(item, index) in webPositionData[3]['infoData']"
              :key="index"
              @click="detailHandle(item)"
              v-show="1 < index && index < 8"
            >
              <span></span>
              {{ item.strMasTitle }}
            </li>
          </ul>
        </div>
        <div v-else class="no-content">暂无数据</div>
      </div>
    </div>
    <div class="qh-new-main">
      <div class="qh-schedule container">
        <div class="qh-schedule-title">
          <div class="qh-schedule-title-left">
            <img src="../assets/images/1304/ico1.png" alt="" />
            <span>全会·日程</span>
          </div>
          <div
            class="more-detail"
            @click="toList(webPositionData[2].strId)"
            v-if="webPositionData[2] && webPositionData[2].infoData.length > 0"
          >
            更多>>
          </div>
        </div>
        <div class="qh-schedule-con">
          <div
            class="qh-schedule-con-item"
            v-if="webPositionData[2] && webPositionData[2].infoData.length > 0"
            @click="detailHandle(webPositionData[2]['infoData'][0])"
          >
            <div class="qh-schedule-con-item-left">{{ webPositionData[2]['infoData'][0].strMasTitle }}</div>
            <div class="qh-schedule-con-item-right">
              <span class="text">
                {{ webPositionData[2].infoData[0].strConTentTxt }}
              </span>
              <span class="more"> [详细] </span>
            </div>
            <div style="clear: both"></div>
          </div>
          <div v-else class="no-content">暂无数据</div>
        </div>
      </div>
      <!-- 全会·在现场 & 全会·融媒汇 -->
      <div class="container qh-section-wrap">
        <!-- 左侧：全会·在现场 -->
        <div class="qh-section-item" v-if="webPositionData[4]">
          <div class="qh-section-title">
            <img src="../assets/images/1304/section-title1.png" alt="全会·在现场" />
          </div>
          <div class="qh-section-content">
            <!-- 顶部图片（第一条数据） -->
            <div class="qh-static-img-wrap" v-if="webPositionData[4]['infoData'].length > 0">
              <div class="qh-static-img" @click="detailHandle(webPositionData[4]['infoData'][0])">
                <img :src="webPositionData[4]['infoData'][0].strPicPath" :alt="webPositionData[4]['infoData'][0].strMasTitle" />
              </div>
              <!-- 图片标题 -->
              <div class="qh-static-title left-title" @click="detailHandle(webPositionData[4]['infoData'][0])">
                {{ webPositionData[4]['infoData'][0].strMasTitle }}
              </div>
            </div>
            <div v-else class="no-content">暂无数据</div>
            <!-- 新闻列表（从第2条开始） -->
            <ul class="qh-news-list qh-news-list-left" v-if="webPositionData[4]['infoData'].length > 1">
              <li
                v-for="(item, index) in webPositionData[4]['infoData'].slice(1)"
                :key="'news1-' + index"
                @click="detailHandle(item)"
              >
                <span class="qh-dot"></span>
                <span class="qh-news-text text-one">{{ item.strMasTitle }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- 右侧：全会·融媒汇 -->
        <div class="qh-section-item" v-if="webPositionData[5]">
          <div class="qh-section-title">
            <img src="../assets/images/1304/section-title2.png" alt="全会·融媒汇" />
          </div>
          <div class="qh-section-content right-content">
            <!-- 顶部图片（第一条数据） -->
            <div class="qh-static-img-wrap" v-if="webPositionData[5]['infoData'].length > 0">
              <div class="qh-static-img" @click="detailHandle(webPositionData[5]['infoData'][0])">
                <img
                  :src="webPositionData[5]['infoData'][0].strPicPath"
                  :alt="webPositionData[5]['infoData'][0].strMasTitle"
                />
              </div>
              <!-- 图片标题 -->
              <div class="qh-static-title" @click="detailHandle(webPositionData[5]['infoData'][0])">
                {{ webPositionData[5]['infoData'][0].strMasTitle }}
              </div>
            </div>
            <div v-else class="no-content">暂无数据</div>
            <!-- 新闻列表（从第2条开始） -->
            <ul class="qh-news-list qh-news-list-right" v-if="webPositionData[5]['infoData'].length > 1">
              <li
                v-for="(item, index) in webPositionData[5]['infoData'].slice(1)"
                :key="'news2-' + index"
                @click="detailHandle(item)"
              >
                <span class="qh-news-text text-one">{{ item.strMasTitle }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 全会·委员访谈 & 全会·大会发言 -->
    <div class="qh-talk-section container">
      <!-- 左侧：全会·委员访谈 -->
      <div class="qh-talk-item" v-if="webPositionData[6]">
        <div class="qh-talk-header" @click.stop="toList(webPositionData[6].strId)">
          <img src="../assets/images/1304/section-title3.png" alt="全会·委员访谈" />
        </div>
        <div class="qh-talk-content">
          <ul v-if="webPositionData[6]['infoData'].length > 0">
            <li
              v-for="(item, index) in webPositionData[6]['infoData']"
              :key="index"
              @click="detailHandle(item)"
              v-show="index < 5"
            >
              <span class="qh-talk-dot"></span>
              <span class="qh-talk-text text-one">{{ item.strMasTitle }}</span>
            </li>
          </ul>
          <div v-else class="no-content">
            <img src="../assets/images/data_null.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 右侧：全会·大会发言 -->
      <div class="qh-talk-item" v-if="webPositionData[7]">
        <div class="qh-talk-header" @click.stop="toList(webPositionData[7].strId)">
          <img src="../assets/images/1304/section-title4.png" alt="全会·大会发言" />
        </div>
        <div class="qh-talk-content">
          <ul v-if="webPositionData[7]['infoData'].length > 0">
            <li
              v-for="(item, index) in webPositionData[7]['infoData']"
              :key="index"
              @click="detailHandle(item)"
              v-show="index < 5"
            >
              <span class="qh-talk-dot"></span>
              <span class="qh-talk-text text-one">
                <font style="color:red">{{item.strSecTitle}}</font>{{ item.strMasTitle }}
              </span>
            </li>
          </ul>
          <div v-else class="no-content">
            <img src="../assets/images/data_null.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="new-common-tit">
      <img src="../assets/images/1304/section-title5.png" alt="" />
    </div>
    <div class="swiper-pic-main">
      <swiper :options="swiperOptionsPic" v-if="webPositionData[9] && webPositionData[9]['infoData'].length > 0">
        <swiper-slide class="swiper-slide" v-for="item in webPositionData[9]['infoData']" :key="item.strId">
          <router-link
            target="_blank"
            :to="{
              path: '/detail',
              query: {
                strWebSiteId: $route.query.strWebSiteId,
                strId: item.strId,
              },
            }"
            class="swiper-pic-link"
          >
            <img :src="item.strPicPath" />
            <div class="swiper-pic-title">{{ item.strMasTitle }}</div>
          </router-link>
        </swiper-slide>
      </swiper>
      <div v-else class="no-content">暂无数据</div>
    </div>
  </div>
</template>

<script>
import Vswiper from '@/components/base/swiper.vue'
import 'swiper/css/swiper.min.css'
import { homeData, bodyData } from '@/api/configuration'
import moment from 'moment'
export default {
  name: 'Home',
  components: {
    Vswiper,
  },
  filters: {
    filterDate(val) {
      return val.slice(0, val.length - 5)
    },
  },
  data() {
    return {
      photoWidth: '', // 精彩图片宽度
      calleft: 0, // 精彩图片左移尺寸
      webPositionData: [], // 中间内容列表
      isSpecial: false,
      currentSlide1: 0, // 左侧轮播图当前索引
      swiperOptionsQh: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination-qh1',
          clickable: true,
        },
      },

      swiperOption: {
        slidesPerView: 4,

        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          // 当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      swiperOptionsPic: {
        slidesPerView: 3,
        // loop: true,
        spaceBetween: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          // 当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      hySwiperOption: {
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        allowTouchMove: false,
        centeredSlides: true,
        spaceBetween: 0,
        slidesOffsetBefore: 40,
        loop: true,
        slidesPerView: 'auto',
        on: {
          slideChangeTransitionEnd: function () {
            this.slides.transition(this.params.autoplay.delay + this.params.speed).transform('translate3d(-60px, 0, 0)')
          },
          slideChangeTransitionStart: function () {
            this.slides.transition(this.params.speed).transform('translate3d(0, 0, 0)')
          },
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      bgSwiperOption: {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      /* eslint-disable no-new */
      bgSwiper: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        slidesPerView: '4',
        spaceBetween: 20,
        slidesOffsetBefore: 105,
        slidesOffsetAfter: 100,
      },
      indexMeet: 0,
    }
  },
  props: {},
  computed: {},
  created() {
    this.isSpecial =
      this.$route.query.strWebSiteId === 'b4a5ad6f2ad74fe6a2310d313bba36b7' ||
      this.$route.query.strWebSiteId === '4b4dc894e2894d4c966c03db2669de03'
    this.getInfoData() // 获取首页数据
  },

  mounted() {
    this.$nextTick(() => {
      console.log('webPositionData:',this.webPositionData)
    })
  },
  methods: {
    moment,
    // 左侧轮播图切换事件
    onSlideChange1() {
      if (this.$refs.swiperQh1 && this.$refs.swiperQh1.$swiper) {
        const swiper = this.$refs.swiperQh1.$swiper
        // loop模式下需要使用realIndex
        this.currentSlide1 = swiper.realIndex || 0
      }
    },
    getTitle(title) {
      let flag = false
      if (title && (title.indexOf('口头') > -1 || title.indexOf('书面') > -1)) {
        flag = true
      }
      return flag
    },
    getDateFn(val, type) {
      let date = val.slice(0, val.length - 5)
      let monethIndex = date.indexOf('月')
      let dayIndex = date.indexOf('日')
      if (type == 0) {
        return date.slice(0, monethIndex + 1)
      } else if (type == 1) {
        return date.slice(monethIndex + 1, dayIndex + 1)
      } else if (type == 2) {
        let time = new Date()
        let year = time.getFullYear()
        let month = date.slice(0, monethIndex)
        let day = date.slice(monethIndex + 1, dayIndex)
        let fullDate = year + '-' + month + '-' + day
        let enMonth = moment(fullDate).format('MMMM')
        return enMonth
      }
    },
    clickMeet(i) {
      this.indexMeet = i
    },
    //获取首页数据
    getInfoData() {
      const that = this
      homeData({
        strWebSiteId:
          // this.$store.state.strWebSiteId || "b4ac4453111f42ea89394a33ea137dbf", // 十三届一次
          this.$store.state.strWebSiteId || 'b4ac4453111f42ea89394a33ea137dbf',
      })
        .then((res) => {
          let firstData = res.data.data
          document.title = firstData.strName
          const data = firstData.webPositionData
          data.forEach(async (v, k) => {
            let curObj = data[k]
            await bodyData({
              strColId: curObj.strColId,
              strColName: curObj.strColName,
              intCount: curObj.intCount,
            })
              .then((res) => {
                const secData = res.data.data
                that.$set(that.webPositionData, k, secData)
                if (k === 5 && secData.infoData && secData.infoData.length) {
                  that.photoWidth = 290 * Number(secData.infoData.length) * 2
                  that.move()
                }
              })
              .catch((err) => {
                that.$message.destroy()
                that.$message.error(err)
              })
          })
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(err)
        })
    },
    //移动
    move() {
      this.timer = setInterval(this.starmove, 20)
    },

    //开始移动
    starmove() {
      this.calleft -= 0.6
      let lengthVal = this.webPositionData[5]['infoData'].length
      if (this.calleft <= -(290 * Number(lengthVal))) {
        this.calleft = 0
      }
    },

    //鼠标悬停时停止移动
    stopmove() {
      clearInterval(this.timer)
    },

    // 更多菜单跳转
    navHandle(strId) {
      let routeData = this.$router.resolve({
        path: '/list',
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
      })
      window.open(routeData.href, '_blank')
    },

    // 跳转详情
    detailHandle(i) {
      if (i.strUrlType == '_blank') {
        window.open(i.strUrl, i.strUrlType)
      } else {
        let routeData = this.$router.resolve({
          path: '/detail',
          query: {
            strWebSiteId: this.$route.query.strWebSiteId,
            strId: i.strId,
          },
        })
        window.open(routeData.href, '_blank')
      }
    },
    toList(strId) {
      let routeData = this.$router.resolve({
        path: '/list',
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
      })
      window.open(routeData.href, '_blank')
    },
    toScheduleList(strId) {
      let routeData = this.$router.resolve({
        path: '/scheduleList',
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.swiper-pic-main {
  height: 450px;
  margin: 20px auto 100px !important;

  // width: 1200px;
  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide-next {
    // height: 400px!important;
    transform: scale(1) !important;
  }

  // .swiper-slide-next + .swiper-slide{
  //   transform: scale(1)!important;
  // }
  .swiper-slide {
    // width: 400px;
    // height: 300px;
    transform: scale(0.8);

    .swiper-pic-link {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .swiper-pic-title {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 12px 15px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
      color: #fff;
      font-size: 20px;
      line-height: 1.4;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: none;
    }
  }
}

.bgjd-main {
  background: url('../assets/images/bg-bg.png') no-repeat center center;
  background-size: 100% 100%;

  .bgjd-flex {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }

  .bg-left {
    width: 50%;

    li {
      font-size: 14px;
      position: relative;
      padding-left: 100px;
      margin-bottom: 55px;
      padding-right: 30px;

      &:nth-child(2) {
        .bg-text {
          background-color: #fbb8b1;
        }
      }

      &:nth-child(3) {
        .bg-text {
          background-color: #fccd80;
        }
      }

      .bg-text {
        background-color: #c8dcfe;
        font-size: 14px;
        line-height: 24px;
        padding: 15px;
        border-radius: 10px;

        &::after {
          content: '';
          position: absolute;
          width: 2px;
          height: 100%;
          background-color: orange;
          left: 34px;
          top: 0px;
        }

        &::before {
          content: '';
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: orange;
          left: 30px;
          top: 100%;
          // transform: translateX(-50%);
        }
      }

      &:last-child {
        .bg-text {
          // &::after {
          //   // content: '';
          //   height: 50%;
          //   // transform: translateX(-50%);
          // }
          &::before {
            top: 100%;
            // transform: translateX(-50%);
          }
        }
      }

      &:first-child {
        .tit-bg::after {
          display: none !important;
        }
      }

      .tit-bg {
        font-size: 14px;
        color: #fff;
        background: url('../assets/images/bgjd-tit-bg.png') no-repeat center center;
        background-size: 100% 100%;
        width: 80px;
        height: 55px;
        padding: 5px 20px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;

        &::after {
          content: '';
          position: absolute;
          width: 2px;
          height: 100%;
          background-color: orange;
          left: 34px;
          top: -55px;
        }
      }

      // &::after{
      //   content
      // }
    }
  }

  .bg-right {
    width: 50%;

    .bg-right-t {
      height: 280px;
      border: 1px solid #ddd;
      border-radius: 10px;

      .swiper {
        width: 600px;
        height: 280px;
        box-sizing: border-box;
        border: 1px solid #eee;
        border-radius: 10px;

        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          background-size: cover;
          overflow: hidden;

          img {
            display: block;
            width: 100%;
            height: 100%;
            margin: 0 auto;
          }

          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            height: 70px;
            line-height: 40px;
            box-sizing: border-box;
            padding: 2px 0 0 0;
            font-size: 18px;
            color: #fff;
            font-family: Verdana;
            margin: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: center;

            span {
              width: 85%;
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .swiper-pagination {
          bottom: 6px;
          box-sizing: border-box;
          padding: 0 5px;
          text-align: center;
          z-index: 1;
          right: 0;
          left: 0;
          width: auto;

          /deep/ .swiper-pagination-bullet {
            width: 12px !important;
            height: 12px !important;
            opacity: 1;
            background: #d9d9d9;

            &:hover {
              opacity: 1;
            }

            &.swiper-pagination-bullet-active {
              background: linear-gradient(90deg, #f71d1d, #fba548);
            }
          }
        }
      }
    }

    .bg-right-b {
      margin-top: 30px;

      .no-content {
        min-height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
      }

      .swiper-button-prev:after,
      .swiper-button-next:after {
        content: '' !important;
      }

      /deep/.swiper-container {
        // overflow: inherit;
        width: 100%;

        .swiper-wrapper {
          padding: 0 51px;
          box-sizing: border-box;

          // width: 1000px;
          .swiper-slide {
            position: relative;
            text-align: center;

            img {
              width: 100%;
              height: 130px;
              border-radius: 10px;
              // border-radius: 50%;
              // border: 1px solid #ffe9c5;
            }
          }
        }
      }
    }
  }
}

.hy-swiper-main {
  height: 600px;
  margin-top: 100px;

  /deep/.swiper-container {
    .swiper-slide {
      width: 978px;
      transition-timing-function: linear;
      position: relative;
    }

    .swiper-button-prev:after,
    .swiper-button-next:after {
      content: '' !important;
    }

    .swiper-slide::after {
      content: '';
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      top: 0;
      left: 0;
    }

    .swiper-slide-active.swiper-slide::after {
      display: none;
    }

    .swiper-button-prev,
    .swiper-button-next {
      background: transparent;
      width: 22%;
      height: 100%;
      top: 0;
    }

    .swiper-button-prev {
      left: 0;
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-slide img {
      width: 100%;
      height: 600px;
    }
  }

  .no-content {
    border: 1px dashed #ccc;
  }
}

.fc-swiper-main {
  width: 100%;

  .swiper-button-prev:after,
  .swiper-button-next:after {
    content: '' !important;
  }

  .swiper-button-prev {
    width: 30px;
    height: 30px;
    left: 0px;
    background: url('../assets/images/wyfc-arrow-l.png') no-repeat center center;
    background-size: 100% 100%;
  }

  .swiper-button-next {
    width: 30px;
    height: 30px;
    right: 0px;
    background: url('../assets/images/wyfc-arrow-r.png') no-repeat center center;
    background-size: 100% 100%;
  }

  /deep/.swiper-container {
    // overflow: inherit;
    width: 1300px;

    .swiper-wrapper {
      padding: 0 51px;
      box-sizing: border-box;
      width: 1000px;

      .swiper-slide {
        position: relative;
        padding: 10px 0 10px 10px;

        .img {
          border: 3px solid #ffe9c5;
          border-radius: 50%;
          padding: 5px;
          width: 200px;
          height: 200px;
          // margin: 0 auto;
          box-shadow: 0px 1px 10px 5px #ffe9c5;
        }

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid #ffe9c5;
        }

        span {
          position: absolute;
          left: 0px;
          bottom: 5px;
          font-size: 16px;
          font-weight: 700;
          width: 70px;
          height: 70px;
          background: #ffe9c5;
          text-align: center;
          line-height: 70px;
          border-radius: 50%;
          box-shadow: 0 0 10px 1px #cfc9c9;
        }
      }
    }
  }

  .no-content {
    border: 1px dashed #ccc;
  }
}

.new-common-tit2 {
  font-size: 70px;
  color: #f00400;
  text-align: center;
  font-weight: 700;
  padding: 50px 156px 50px 0;
  font-family: cursive;
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.new-common-tit {
  padding: 0 50px;
  margin: 100px auto 100px auto;
  img {
    width: 100%;
  }
}

.wy-new-main {
  background: url('../assets/images/1303/book2.png') no-repeat center center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-bottom: 60px;
  height: 500px;
  width: 1200px;

  .no-content {
    // background-color: #ffe9c5;
    border-radius: 10px;
    min-height: 190px !important;

    img {
      width: 200px;
      margin-top: 30px;
    }
  }

  .wy-flex {
    width: 887px !important;
    display: flex;
    background: url('../assets/images/1303/juxing.png') no-repeat center 33px;
    background-size: 100% 100%;
    border-radius: 14px;
    height: 376px;

    // background: url("../assets/images/img6.png") no-repeat center center / 100%      100%;
    // height: 500px;
    .wy-new-item {
      cursor: pointer;
      width: 50%;

      &:first-child {
        padding-right: 25px;

        ul {
          // background-color: #ffe9c5;
          padding: 10px 20px 10px 10px;
          border-radius: 10px;
        }

        .wy-item-tit {
          margin-top: 40px;
        }
      }

      &:last-child {
        padding-left: 25px;

        ul {
          // background-color: #ffe9c5;
          padding: 10px 30px 10px 10px;
          border-radius: 10px;
        }

        .wy-item-tit {
          padding-right: 50px;
        }
      }

      li {
        font-size: 16px;
        color: #333;
        height: 40px;
        line-height: 30px;
        position: relative;
        padding: 0 20px 0 20px;
        // background: #efefef;
        margin-bottom: 15px;
        border-bottom: 1px dashed #333;
        cursor: pointer;

        .wy-li-text {
          width: 100%;
          display: inline-block;
          color: #343434;
          margin-left: 4px;
          .red {
            color: red;
          }
        }

        .tag-li {
          width: 16px;
          height: 16px;
          background: #ffba00;
          position: absolute;
          left: 0;
          top: 40%;
          border-radius: 50%;
          transform: translateY(-50%) rotate(45deg);
        }
      }

      .wy-item-tit {
        text-align: center;
        // margin-bottom: 36px;
        margin-top: 40px;

        img {
          scale: 0.7;
        }

        span {
          // background: url("../assets/images/list-tit-bg-2.png") no-repeat center
          //   center;
          // background-size: 100% 100%;
          font-size: 24px;
          color: #000;
          font-weight: 700;
          vertical-align: middle;
          // padding: 10px 50px 30px 50px;
        }
      }
    }
  }
}

// 全会·委员访谈 & 全会·大会发言 新样式
.qh-talk-section {
  width: 1400px!important;
  display: flex;
  justify-content: space-between;
  gap: 90px;
  padding: 40px 0;
  margin-bottom: 40px;

  .qh-talk-item {
    flex: 1 1 0;
    min-width: 0;

    .qh-talk-header {
      cursor: pointer;
      margin-bottom: 0;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .qh-talk-content {
      background: url('../assets/images/1304/section-bg1.png') no-repeat center center;
      background-size: 100% 100%;
      min-height: 280px;
      padding: 25px 25px 25px 55px;
      margin: 50px 30px 0 30px;

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: 1px dashed #e0e0e0;
          cursor: pointer;
          transition: all 0.3s ease;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            .qh-talk-text {
              color: #c10400;
            }
          }
        }
      }

      .no-content {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;

        img {
          width: 150px;
        }
      }
    }

    // 左侧圆点样式
    .qh-talk-dot {
      width: 10px;
      height: 10px;
      background-color: #c10400;
      border-radius: 50%;
      flex-shrink: 0;
      margin-right: 12px;
    }

    // 右侧标签样式
    .qh-talk-tag {
      display: inline-block;
      padding: 2px 6px;
      font-size: 14px;
      color: #c10400;
      flex-shrink: 0;
      margin-right: 8px;
      white-space: nowrap;

      &.red-tag {
        color: #c10400;
        font-weight: 500;
      }
    }

    .qh-talk-text {
      flex: 1;
      font-size: 20px;
      color: #333;
      line-height: 1.6;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .red {
        color: #c10400;
      }
    }
  }
}

.qh-new-main {
  margin: 0 auto;
  .qh-schedule {
    margin: 40px auto 100px !important;
    background: url('../assets/images/1304/box-img.png') no-repeat center center;
    background-size: 100% 100%;

    .qh-schedule-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
      font-weight: 700;
      padding-left: 45px;
      background-size: 100% 100%;
      color: #c10400;
      padding-right: 45px;

      img {
        width: 35px;
        margin-right: 10px;
        vertical-align: middle;
      }
      .qh-schedule-title-left {
        display: flex;
        align-items: center;
      }
      .qh-schedule-title-right {
        font-size: 20px;
        color: #c10400;
      }
    }

    .qh-schedule-con {
      padding: 40px 45px 20px 45px;

      // min-height: 200px;
      .no-content{
        min-height: 50px;
      }
      .more-detail {
        font-size: 20px;
        text-align: right;
        padding-right: 30px;
        color: #919191;
        cursor: pointer;
      }

      .qh-schedule-con-item {
        width: 100%;
        padding: 0px 40px;
        min-height: 40px;
        line-height: 40px;
        margin-bottom: 25px;
        cursor: pointer;
        border-bottom: 1px dashed #c10400;
        padding-bottom: 15px;

        .qh-schedule-con-item-left {
          float: left;
          font-size: 28px;
          font-weight: 700;
          color: #d21a24;
          width: 30%;
        }

        .qh-schedule-con-item-right {
          float: right;
          font-size: 20px;
          width: 50%;

          span.text {
            display: inline-block;
            width: calc(100% - 60px);
            // width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
            text-align: right;
          }

          span.more {
            display: inline-block;
            width: 60px;
            cursor: pointer;
          }
        }
      }
    }
  }

  // 全会·在现场 & 全会·融媒汇 新样式
  .qh-section-wrap {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    padding: 20px 0;
    width: 1400px!important;
  }

  .qh-section-item {
    flex: 1;
    max-width: 48%;
  }

  .qh-section-title {
    margin-bottom: 15px;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .qh-section-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  .right-content {
    background: #EFEFEF;
  }

  // 左侧轮播图样式
  .qh-swiper-wrap {
    margin-bottom: 15px;

    .swiper-container {
      border-radius: 10px;
      overflow: hidden;
    }

    .qh-slide-img {
      position: relative;
      cursor: pointer;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 280px;
        object-fit: cover;
        display: block;
        border-radius: 10px;
      }

      .qh-slide-mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 52px;
        background: #cdcdd3;
        border-radius: 0 0 10px 10px;
        opacity: 0.39;
      }
    }

    // 轮播分页器样式
    /deep/ .swiper-pagination-qh1 {
      bottom: 15px;

      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        background: #fff;
        opacity: 0.8;

        &.swiper-pagination-bullet-active {
          background: #bf1908;
          opacity: 1;
        }
      }
    }
  }

  .qh-slide-title {
    font-size: 18px;
    color: #000;
    line-height: 1.5;
    margin-top: 12px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: #bf1908;
    }
  }

  // 左侧新闻列表样式
  .qh-news-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      margin-bottom: 10px;
      cursor: pointer;
      border-radius: 4px;

      &:hover {
        .qh-news-text {
          color: #bf1908;
        }
      }
    }

    .qh-dot {
      width: 8px;
      height: 8px;
      background: #bf1908;
      border-radius: 50%;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .qh-news-text {
      flex: 1;
      font-size: 20px;
      color: #000;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .qh-news-list-left {
    .qh-news-text {
      background: url('../assets/images/1304/word-bg.png') no-repeat left 12px;
      background-size: 100% auto;
      padding: 0 8px;
    }
  }

  // 右侧静态图片样式
  .qh-static-img-wrap {
    margin-bottom: 15px;
  }

  .qh-static-img {
    cursor: pointer;
    overflow: hidden;

    img {
      width: 100%;
      height: 360px;
      object-fit: cover;
      display: block;
    }
  }

  .qh-static-title {
    font-size: 20px;
    color: #000;
    line-height: 1.5;
    margin-top: 12px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 10px;
    border-bottom: 1px dashed #333;

    &:hover {
      color: #bf1908;
    }
  }
  .left-title {
    margin-left: 36px;
    border-bottom: 1px dashed #333;
    padding-bottom: 10px;
    width: calc(100% - 57px);
  }

  // 右侧新闻列表（无背景图、无圆点）
  .qh-news-list-right {
    li {
      background: none;
      padding: 8px 0;
      margin-bottom: 5px;
    }

    .qh-dot {
      display: none;
    }
  }

  .qh-flex {
    display: flex;

    ul.ul-news {
      min-height: 370px;
    }

    div.no-content {
      border: 0 solid #f6aeae;
      padding: 30px;
      background-color: #fff;
      border-radius: 10px;
      position: relative;
      height: 370px;
      min-width: 200px;
    }
  }

  .qh-new-item {
    background: #fff;
    position: relative;
    width: 44%;
    min-height: 400px;
    border-radius: 8px;
    border: 1px solid #c72328;

    //background: url("../assets/images/1303/meeting-content1.png") no-repeat center center;
    // background-size: 100% 100%;
    &:first-child {
      margin-right: 190px;
    }

    // &:first-child {

    padding: 70px 0 0 0;

    .qh-item-tit {
      width: 360px;
      height: 60px;
      // line-height: 76px;
      background: url('../assets/images/1303/bg6.png') no-repeat;
      background-size: 100% 100%;
      top: -20px;
      left: -1px;

      span {
        padding: 10px 0 10px 20px;

        img {
          //margin-bottom:6px;
          left: 30px;
        }
      }
    }

    //}
    /*  &:last-child {
      padding: 70px  50px 0 0 ;
      margin-left: 25px;
      .qh-item-tit {
        position: absolute;
        top: 0px;
        right: 0;
        span {
          padding: 10px 0 10px 50px;
          img {
            left: 20px;
          }
        }
      }
    } */
    ul {
      // border: 1px solid #f6aeae;
      padding: 0 10px 0 10px;
      background-color: #fff;
      // border-radius: 10px;
      position: relative;
      top: -10px;
    }

    li {
      font-size: 16px;
      color: #333;
      height: 44px;
      line-height: 44px;
      position: relative;
      padding: 0 20px 0 40px;
      background: url('../assets/images/1303/line1.png') no-repeat;
      background-size: 100% 100%;
      // background: linear-gradient(-45deg, transparent 10px, #d5f5ff 10px);
      margin-bottom: 20px;
      cursor: pointer;

      &::after {
        content: '';
        height: 15px;
        //  background-color: #c3e2ff;
        position: absolute;
        left: 50px;
        right: 20px;
        bottom: 10px;
        // transform: translateX(-50%);
        z-index: 9;
      }

      .qh-li-text {
        width: 100%;
        display: inline-block;
        position: relative;
        z-index: 999;
      }

      img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 16px;
      }

      .tag-li {
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background-color: #bf0707;
        // width: 70px;
        // height: 100%;
        // background: url("../assets/images/li-bg.png") no-repeat center center;
        // background-size: 100% 100%;
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        line-height: 50px;
        text-align: center;
        font-weight: 700;
        color: #fff;
        font-size: 20px;
      }
    }

    .qh-item-tit {
      position: absolute;
      top: -20px;
      // transform: translateX(-50%);
      text-align: center;
      margin-bottom: 50px;
      cursor: pointer;

      span {
        position: relative;
        display: inline-block;
        width: 250px;
        height: 400px;
        // line-height:50px;
        // background: url("../assets/images/img5.png") no-repeat center center;
        background-size: 100% 100%;
        font-size: 28px;
        color: #fff;
        font-weight: 700;
        padding: 8px 40px 10px 40px;

        img {
          position: absolute;
          left: 0px;
          top: 10px;
          width: 40px;
        }
      }
    }
  }
}

.news-kms {
  position: relative;

  .news-main {
    padding: 0 30px;
    width: 600px;

    /* position: absolute;
    top: 0;
    right: 0; */
    .rows-zt {
      border-bottom: 1px dashed #bababa;
      margin-bottom: 15px;
      cursor: pointer;

      &:nth-child(2) {
        margin-bottom: 0;
      }

      .tit-zt {
        font-size: 20px;
        color: #d21a24;
        font-weight: 700;
        padding-bottom: 10px;
        width: 100%;

        // white-space: nowrap;
        // text-overflow: ellipsis;
        // overflow: hidden;
        .text {
          display: inline-block;
          width: 90%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .more {
          font-size: 14px;
          color: #bcbcbc;
          float: right;
          margin-top: 5px;
        }
      }

      .con-zt {
        font-size: 14px;
        margin-bottom: 15px;
        color: #727272;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    ul {
      margin-top: 5px;
      margin-bottom: 0 !important;
      height: 140px;
      overflow: hidden;

      li {
        position: relative;
        font-size: 16px;
        color: #333;
        line-height: 20px;
        padding: 7px 0 7px 20px;
        border-bottom: 1px dashed #dcdcdc;
        cursor: pointer;

        span {
          width: 5px;
          height: 5px;
          background: #f6aeae;
          position: absolute;
          border-radius: 50%;
          left: 2px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
        }
      }
    }
  }
}

.home {
  // background: url('../assets/images/bg1.png') no-repeat center top,
  //   url('../assets/images/bg2.png') no-repeat center bottom;
  // padding: 65px 0 0px;
  padding: 0;

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .no-content {
    box-sizing: border-box;
    font-size: 18px;
    text-align: center;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.bgHeight {
      background-color: #fff;
      position: absolute;
      height: 350px;
      border-radius: 10px;
      border: 1px solid red;
      min-width: 538px;
    }
  }

  .slogan {
    box-sizing: border-box;
    padding: 30px 15px 30px;

    .tit-box {
      cursor: pointer;
      text-align: center;

      span {
        font-size: 14px;
        color: #545454;
        padding: 0 15px;
        border-right: 1px solid #545454;

        &:last-child {
          border-right: none;
        }
      }
    }

    h2,.sectitle {
      cursor: pointer;
      font-size: 30px;
      font-weight: bold;
      color: #d21a24;
      line-height: 62px;
      text-align: center;
      white-space: wrap;
      //overflow: hidden;
      //text-overflow: ellipsis;

      img {
        width: 95px;
        vertical-align: top;
        margin-right: -15px;
      }
    }

    p {
      font-size: 18px;
      color: #333333;
      line-height: 28px;
    }

    i {
      display: inline-block;
      font-style: normal;
      color: #bb2c1b;
      cursor: pointer;
    }
  }

  .top {
    display: flex;
    justify-content: space-between;

    .tit {
      color: #e40000;
      font-size: 30px;
      font-weight: bold;
      border-left: 8px solid #e40000;
      padding-left: 17px;
      margin: 50px 0 45px 25px;
    }

    & > .news {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;

      .title {
        background: url('../assets/images/tips.png') no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        padding: 0 0 0 20px;

        span {
          font-size: 28px;
          font-weight: bold;
          color: #ce0801;
          line-height: 16px;
        }

        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }

      ul {
        margin-top: 10px;

        li {
          background: url('../assets/images/tips2.png') no-repeat 0 center;
          font-size: 20px;
          color: #333;
          line-height: 25px;
          box-sizing: border-box;
          padding: 15px 0 15px 15px;
          // margin: 16px  0;
          cursor: pointer;
          border-bottom: 1px dashed #ddd;

          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .picture-video {
    margin: 40px auto;
    display: flex;
    justify-content: space-between;

    .picture {
      width: 100%;
      height: 106px;
      background: url('../assets/images/schedule-bg.png') no-repeat left center;
      background-size: 100%;
      position: relative;

      .meet-text {
        width: 50%;
        position: absolute;
        color: #444444;
        font-size: 16px;
        left: 55%;
        top: 110px;
        transform: translate(-50%, -50%);

        .tit {
          color: #f00400;
          font-weight: 700;
          font-size: 18px;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .detail {
          margin-bottom: 5px;
          width: 100%;
          position: relative;
          padding-right: 45px;

          .detail-text {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }

          span {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }

        .time {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .name-box {
        position: absolute;
        left: 133px;
        top: 11px;
        width: 350px;
        padding-left: 100px;

        .meet-name {
          color: #fff;
          font-size: 18px;
          position: absolute;
          left: 0px;
          top: 5px;
        }

        .rc-box {
          overflow-x: auto;
          white-space: nowrap;
          // /* width: 100px; */
          height: 35px;

          .rc-item {
            float: left;
            width: 50px;
            height: 24px;
            position: relative;

            &.on {
              &::before {
                background-color: #f8c985 !important;
              }
            }

            img {
              width: 18px;
            }

            &:last-child {
              &::after {
                display: none !important;
              }
            }

            &::before {
              content: '';
              position: absolute;
              bottom: -10px;
              left: 5px;
              width: 8px;
              height: 8px;
              background-color: #fff;
              border-radius: 50%;
              z-index: 2;
            }

            &::after {
              content: '';
              position: absolute;
              bottom: -7px;
              left: 6px;
              width: 100%;
              height: 1px;
              background-color: #e88969;
            }
          }
        }
      }
    }

    .picture-new {
      padding: 0 0 0 10px;
      background: #eaf5fc url('../assets/images/pic_new.png') no-repeat left center;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .pic_l {
        display: flex;
        align-items: center;

        .date {
          margin-left: 30px;

          .month {
            font-size: 26px;
            color: #4c4c4c;
          }

          .enMonth {
            font-size: 18px;
            font-weight: bold;
            padding-left: 2px;
            color: #bcbcbc;
          }

          .day {
            font-size: 28px;
            font-weight: bold;
            color: #bb2c1b;
          }
        }

        .book {
          margin-left: 30px;
        }

        .title_text {
          margin-left: 30px;

          .new_title {
            font-size: 28px;
            font-weight: bold;
            color: #db0000;
            width: 550px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .new_text {
            display: flex;
            align-items: center;

            .txt {
              display: inline-block;
              // max-width: 150px;
              // text-overflow: ellipsis;
              // overflow: hidden;
              // white-space: nowrap;
              font-size: 28px;
              font-weight: bold;
              // color: #363636;
              color: #db0000;
              cursor: pointer;
            }

            .detail {
              display: inline-block;
              // font-size: 16px;
              font-size: 28px;
              color: #cc3333;
              cursor: pointer;
            }
          }
        }
      }

      .pic_r {
        width: 316px;
        display: flex;
        flex-wrap: wrap;
        margin-right: 30px;

        .clendar {
          padding: 0 10px;
          background-color: #88c1de;
          font-size: 20px;
          margin-right: 15px;
          margin-bottom: 15px;
          border-radius: 5px;
          color: #fff;
          cursor: pointer;

          &:nth-child(3n) {
            margin-right: 0;
          }

          &:nth-child(n + 4) {
            margin-bottom: 0;
          }
        }

        .c_active {
          background-color: #ed0000 !important;
        }
      }
    }

    .video {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      margin-top: -50px;

      .title {
        background: url('../assets/images/tips.png') no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        padding: 0 0 0 20px;
        margin-bottom: 20px;

        span {
          font-size: 28px;
          font-weight: bold;
          color: #ce0801;
          line-height: 16px;
        }

        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }

      ul {
        height: 235px;

        li {
          position: relative;

          img {
            display: block;
            width: 100%;
            height: 235px;
          }

          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            line-height: 37px;
            background: rgba(0, 0, 0, 0.6);
            box-sizing: border-box;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-family: Verdana;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }

  .conference {
    .title {
      margin: 0 auto 30px;

      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }

    .row {
      display: flex;
      justify-content: space-between;

      .left {
        width: 600px;
        height: 415px;

        .no-content {
          width: 600px;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }

        & > div {
          position: relative;
        }

        img {
          display: block;
          width: 100%;
          height: 415px;
        }

        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0;
          line-height: 37px;
          background: rgba(0, 0, 0, 0.6);
          box-sizing: border-box;
          padding: 0 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 18px;
          font-family: Verdana;
          color: #fff;
          cursor: pointer;
        }
      }

      .right {
        box-sizing: border-box;
        padding-right: 20px;
        flex: 1;
        overflow: hidden;

        &:nth-child(2) {
          margin-left: 45px;
        }

        .no-content {
          width: 100%;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }

        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row wrap;

          li {
            &:nth-child(odd) {
              width: 50%;
            }

            &:nth-child(even) {
              width: calc(50% - 35px);
            }

            div {
              background: url('../assets/images/tips2.png') no-repeat 0 center;
              font-size: 20px;
              color: #333;
              line-height: 25px;
              box-sizing: border-box;
              padding: 15px 0 15px 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
              border-bottom: 1px dashed #ddd;
            }
          }
        }
      }
    }
  }

  .photo-gallery {
    .threeImg .containt {
      position: relative;
      overflow-y: auto;
      width: 1200px;
      height: 165px;
      overflow: hidden;
      margin: 30px auto 10px;

      ul {
        margin: 0 auto;
        width: 2000px;
        position: absolute;
        left: 0px;
        height: 100%;
        z-index: 10;

        li {
          float: left;
          width: 240px;
          height: 165px;
          margin-right: 50px;
          overflow: hidden;
          cursor: pointer;

          img {
            width: 100%;
            height: 135px;
          }

          p {
            display: block;
            width: 100%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #3273dc;
            font-size: 16px;
            cursor: pointer;
            line-height: 40px;
          }
        }
      }
    }
  }

  .links {
    .tit {
      margin: 50px auto 30px;

      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }

    ul li {
      width: 190px;
      margin: 0 5px 0;
      cursor: pointer;

      img {
        display: block;
        margin: 0 auto;
        width: 190px;
        height: 85px;
        border: 1px solid #eee;
      }
    }
  }
}
.swiper-slide-next {
  .swiper-pic-title {
    display: block !important;
  }
}
.home .h2-title{
  display: flex;
  justify-content: center; 
  gap: 20px;
  .img{
    width: 95px;
    height: 38px;
  }
  p.firsttitle{
    cursor: pointer;
    font-size: 30px;
    font-weight: 700;
    color: #d21a24;
    line-height: 62px;
    text-align: center;
    white-space: wrap;
  }
}
</style>
